import { useState, memo, useCallback } from 'react';
import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';
// @mui
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import Stack from '@mui/material/Stack';
import InputBase from '@mui/material/InputBase';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import Dialog, { dialogClasses } from '@mui/material/Dialog';
// hooks
import { useBoolean } from 'src/hooks/use-boolean';
import { useResponsive } from 'src/hooks/use-responsive';
import { useEventListener } from 'src/hooks/use-event-listener';
// components
import Label from 'src/components/label';
import Iconify from 'src/components/iconify';
import Scrollbar from 'src/components/scrollbar';
import { useRouter } from 'src/routes/hooks';
import SearchNotFound from 'src/components/search-not-found';
//
import ResultItem from './result-item';
import { useNavData } from '../../dashboard/config-navigation';
import { applyFilter, groupedData, getAllItems } from './utils';
import "./style.css"
import { LeftIcon } from 'src/components/carousel/arrow-icons';
import { useAuthContext } from 'src/auth/hooks';

// ----------------------------------------------------------------------

function Searchbar() {
  const theme = useTheme();

  const router = useRouter();

  const search = useBoolean();

  const mdUp = useResponsive('up', 'md');

  const [searchQuery, setSearchQuery] = useState('');
  const { user } = useAuthContext()

  const navData = useNavData();
console.log(user,"herhebhr")
  const handleClose = useCallback(() => {
    search.onFalse();
    setSearchQuery('');
  }, [search]);

  const handleKeyDown = (event) => {
    if (event.key === 'k' && event.metaKey) {
      search.onToggle();
      setSearchQuery('');
    }
  };

  useEventListener('keydown', handleKeyDown);

  const handleClick = useCallback(
    (path) => {
      if (path.includes('http')) {
        window.open(path);
      } else {
        router.push(path);
      }
      handleClose();
    },
    [handleClose, router]
  );

  const handleSearch = useCallback((event) => {
    setSearchQuery(event.target.value);
  }, []);

  const dataFiltered = applyFilter({
    inputData: getAllItems({ data: navData }),
    query: searchQuery,
  });

  const notFound = searchQuery && !dataFiltered.length;

  const renderItems = () => {
    const data = groupedData(dataFiltered);

    return Object.keys(data)
      .sort((a, b) => -b.localeCompare(a))
      .map((group, index) => (
        <List key={group || index} disablePadding>
          {data[group].map((item) => {
            const { title, path,role } = item;
            const partsTitle = parse(title, match(title, searchQuery));

            const partsPath = parse(path, match(path, searchQuery));

            return (
              user?.role[0]?.name==role &&
              <ResultItem
                path={partsPath}
                title={partsTitle}
                key={`${title}${path}`}
                groupLabel={searchQuery && group}
                onClickItem={() => handleClick(path)}
              />
            );
          })}
        </List>
      ));
  };

  const renderButton = (
    <Stack direction="row" alignItems="center" mr={2.0} >
      <InputBase
        className='placeholder_search'
        onClick={search.onTrue}
        placeholder="Search your page..."
        value={searchQuery}
        fontFamily="arial"
        onChange={handleSearch}
        sx={{
          height: 35,
          width: "375px",
          borderRadius: 1,
          padding: "19px",
          pl: "3px",
          pr: "5px",
          border: "1px double #e3e3e3",
          zIndex: 1,
          bgcolor: 'common.white',
          fontFamily: 'Arial, sans-serif',
          color: '#333',
          boxShadow: "2px 2px 2px  #e3e3e3",
          transition: ' 0.1s ease',
          '&:hover': {
            border: "3px double #414a4c",
          },
        }}
        startAdornment={
          <InputAdornment position="start">
            <IconButton >
              <Iconify icon="eva:search-fill" color="#111" />
            </IconButton>
          </InputAdornment>
        }
        endAdornment={mdUp && <Label sx={{ p: 1.2, px: 1, fontSize: 12, color: "#fff", backgroundColor: "#3b82f6" }}>⌘ K</Label>}
        inputProps={{
          sx: { typography: 'h6' },
        }}
      />
    </Stack>

  );

  return (
    <>
      {renderButton}

      <Dialog
        fullWidth
        maxWidth="sm"
        open={search.value}
        onClose={handleClose}
        transitionDuration={{
          enter: theme.transitions.duration.shortest,
          exit: 0,
        }}
        PaperProps={{
          sx: {
            mt: 15,
            overflow: 'unset',
          },
        }}
        sx={{
          [`& .${dialogClasses.container}`]: {
            alignItems: 'flex-start',
          },
        }}
      >
        <Box sx={{ p: 3, borderBottom: `solid 1px ${theme.palette.divider}` }}>
          {/* <InputBase
            fullWidth
            placeholder="Email"
            endAdornment={
              <Button color="warning" variant="contained" size="small" sx={{ mr: 0.5 }}>
                Invite
              </Button>
            }
            sx={{
              pl: 1.5,
              height: 40,
              borderRadius: 1,
              bgcolor: 'common.white',
            }}
          /> */}
          <InputBase
            fullWidth
            autoFocus
            placeholder="Search..."
            value={searchQuery}
            onChange={handleSearch}
            sx={{
              pl: 1.5,
              height: 40,
              borderRadius: 1,
              border: "2px double black",
              bgcolor: 'common.white',
            }}
            startAdornment={
              <InputAdornment position="start">
                <Iconify icon="eva:search-fill" width={24} sx={{ color: 'text.disabled' }} />
              </InputAdornment>
            }
          // endAdornment={<Label sx={{ letterSpacing: 1, color: 'text.secondary' }}>X</Label>}
          // inputProps={{
          //   sx: { typography: 'h6' },
          // }}
          />
        </Box>

        <Scrollbar sx={{ p: 3, pt: 2, height: 400 }}>
          {notFound ? <SearchNotFound query={searchQuery} sx={{ py: 10 }} /> : renderItems()}
        </Scrollbar>
      </Dialog>
    </>
  );
}

export default memo(Searchbar);
